export enum ModalActionEnum {
  Cancel = 'cancel',
  Save = 'save',
  CancelForRequestAddTripComment = 'CancelForRequestAddTripComment',
  SaveForRequestAddTripComment = 'SaveForRequestAddTripComment'
}
